<template>
  <div>
    <table style="width: 100%;border-collapse:separate; border-spacing:0px 0px;">
      <tr>
        <td class="my-leftmenu-td1">
          <span class="my-leftmenu-span1">产品展示</span>
        </td>
      </tr>
      <tr>
        <td>
          <el-menu :default-active="getDefaultActive" class="el-menu-vertical-demo" style="width:100%;background:#d3d4d6;">
            <el-menu-item v-for="(item,index) in itemMenu" :key="item.id" :index="item.id" @click="parentClick(item.id)">
              <span slot="title" class="my-leftmenu-span2">{{item.name}}</span>
            </el-menu-item>
          </el-menu>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  export default {
    name: "LeftMenu",
    props: ["itemMenu"],
    methods: {
      parentClick(value) {
        this.$store.state.myactive = "" + (value)
        this.$router.push({
          path: "/item/index?nid=" + value
        });
      },
    },
    data: function() {
      return {};
    },
    computed: {
      getDefaultActive() {
        return this.$store.state.myactive;
      }
    },
  }
</script>

<style>
  .my-leftmenu-td1 {
    background: royalblue;
    height: 70px;
    padding: 0;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-leftmenu-span1 {
    color: white;
    font-size: 25px;
    font-weight: bold;

  }

  .my-leftmenu-span2 {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/LeftMenu.vue